export const convertToDateWithLocale = (
  value: string,
  includeTime: boolean = false,
): Date | undefined => {
  if (!value || isNaN(Date.parse(value))) {
    return undefined;
  }
  const date = new Date(value);
  if (!includeTime) {
    // force to midnight UTC
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  }
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
  );
};

export const formatDateFieldInput = (
  date: Date | string | undefined,
  includeTime: boolean = false,
): string => {
  if (!date) return '';

  const d = typeof date === 'string' ? new Date(date) : date;

  if (isNaN(d.getTime())) {
    return '';
  }

  // Convert from UTC to local time
  const localDate = new Date(d.getTime());

  const year = String(localDate.getFullYear()).padStart(4, '0');
  const month = String(localDate.getMonth() + 1).padStart(2, '0');
  const day = String(localDate.getDate()).padStart(2, '0');

  if (includeTime) {
    const hour = String(localDate.getHours()).padStart(2, '0');
    const minute = String(localDate.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hour}:${minute}`;
  }
  return `${year}-${month}-${day}`;
};

export const formatDateString = (dateStr: string) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toISOString().split('T')[0]; // For date input
};

export const formatDisplayDate = (date: Date | undefined, includeTime: boolean = false): string => {
  if (!date) {
    return '';
  }
  if (includeTime) {
    return new Date(date).toLocaleTimeString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });
  }

  return new Date(date).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

export const formatDateTime = (dateTimeStr: string) => {
  const date = new Date(dateTimeStr);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }).format(date);
};

export const isAtLeastTenYearsAgo = (date: Date) => {
  if (!date) return false;
  const tenYearsAgo = new Date();
  tenYearsAgo.setFullYear(tenYearsAgo.getFullYear() - 10);
  return new Date(date) <= tenYearsAgo;
};
